import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'

import {RCFA_OVERVIEW_WIDGET_NAMESPACE} from '../consts'

const rcfaOverviewTranslationModule: TranslationModule = {
  namespace: RCFA_OVERVIEW_WIDGET_NAMESPACE,
  resources: {
    'de-DE': () => import('./de_DE.json'),
    'en-GB': () => import('./en_GB.json'),
    'en-US': () => import('./en_GB.json')
  }
}

const externalPackageTranslations: TranslationModule[] = []

export const rcfaOverviewWidgetTranslations = combineTranslationBundles([
  externalPackageTranslations,
  rcfaOverviewTranslationModule
])
